<div class="home-meeting-wrapper">
	<div class="home-meeting-upper-details-wrapper">
		<div class="home-meeting-upper-details">
			<div class="firstcol">
				@if (followup.meetingtype_id == -1) {
					{{ "former_debt" | langVal }}
				} @else {
					<label>{{ "meetingtype" | langVal }}</label>
					<app-gen-autocomplete
						#meetingtypeAc
						[actualObj]="followup"
						fieldName="meetingtype_id"
						tabindex="-1"
						title_ph_lang="meetingtype"
						[fuzzySearchableClasses]="['meetingtypes']"
						[error]="errors.meetingtype_id"
						(chosenEvent)="validateAndSave()"
					/>
				}
			</div>
			<div class="grid-span-2">
				@if (
					permsService?.perms?.clinic_financial ||
					permsService?.perms?.administrative
				) {
					<label>{{ priceTitle() | langVal }}</label>
					<app-gen-input
						tabindex="-1"
						className="input-number"
						[actualObj]="followup"
						[errors]="errors"
						isNumber
						fieldName="price"
						(keyupEvent)="validateField()"
						(changeEvent)="save()"
						[disabled]="store.hasInvoiceIdPerson(followup)"
					/>
				}
			</div>

			<div>
				<label>{{ "time" | langVal }}</label>
				<app-gen-input
					disabled
					[actualObj]="followup"
					[errors]="errors"
					className="border-0"
					fieldName="time"
					(keyupEvent)="validateField()"
				/>
			</div>
			<div>
				<label>{{ "length" | langVal }}</label>
				<app-gen-input
					disabled
					[actualObj]="followup"
					[errors]="errors"
					className="border-0"
					fieldName="length"
					(keyupEvent)="validateField()"
				/>
			</div>
			<div class="firstcol">
				@if (patient) {
					@if (patient.is_group == "yes") {
						<button
							(click)="openGroupAttendModal()"
							class="btn btn-primary"
							[disabled]="enableGroupAttendsOnFollowup"
						>
							{{ (hasNonAttend ? "part" : "all_arrived") | langVal }}
						</button>
					} @else {
						<app-yes-no
							(onClick)="changeYesNo('arrived')"
							[isCheck]="followup.arrived == 'yes'"
						></app-yes-no>
						<label (click)="changeYesNo('arrived')">{{
							"arrived" | langVal
						}}</label>
					}
				}
			</div>
			@if (!store.hasInvoiceIdPerson(followup)) {
				<div>
					<app-yes-no
						(onClick)="changeYesNo('charged')"
						[isCheck]="followup.charged == 'yes'"
					></app-yes-no>
					<label (click)="changeYesNo('charged')">{{
						"charged" | langVal
					}}</label>
				</div>
			}

			@if (
				permsService?.perms?.clinic_financial ||
				permsService?.perms?.administrative
			) {
				@if (patient) {
					@if (
						hasPayors &&
						!store.hasInvoiceIdPerson(followup) &&
						!followup.payor_id
					) {
						<div style="grid-column: span 3; margin-inline-start: auto">
							<app-gen-button-group
								[actualObj]="this"
								fieldName="isPayorShown"
								title_ph_lang="payor"
								optionsListName="payor_no_opts"
							/>
						</div>
					}
					@if (store.hasInvoiceIdPerson(followup)) {
						<div
							class="btn paid"
							style="grid-column: span 4"
						>
							@if (followup.invoice_id_patient > 0) {
								{{ "paid_by3" | langVal
								}}{{ followup.finresource_type | langVal }}
								{{ followup.invoice_id_patient }}
								<!--              <app-gen-input title_ph_lang="paid_by_invoice" disabled [actualObj]="followup" [errors]="errors"  className="border-0" fieldName="invoice_id_patient" (keyupEvent)="validateField()" />-->
							} @else {
								{{ "paid" | langVal }}
							}
						</div>
					}
				}
			}
		</div>
		@if (
			permsService?.perms?.clinic_financial ||
			permsService?.perms?.administrative
		) {
			@if (
				(patient && hasPayors && isPayorShown == "yes") || followup.payor_id
			) {
				<div class="home-meeting-upper-details payor-row">
					<div class="firstcol payor">
						<label>{{ "payor" | langVal }}</label>
						<app-gen-autocomplete
							title_ph_lang="payor"
							[actualObj]="followup"
							fieldName="payor_id"
							[disabled]="store.hasInvoiceIdPerson(followup)"
							tabindex="-1"
							[fuzzySearchableClasses]="['payors']"
							[error]="errors.payor_id"
							(chosenEvent)="save()"
						/>
					</div>

					@if (followup.payor_id) {
						<div class="price-payor grid-span-2">
							<label>{{ "price_payor" | langVal }}</label>
							<app-gen-input
								[actualObj]="followup"
								[errors]="errors"
								[disabled]="store.hasInvoiceIdPerson(followup)"
								fieldName="price_payor"
								(keyupEvent)="validateField()"
								(changeEvent)="save()"
							/>
						</div>
						<div>
							<label>{{ "price_patient" | langVal }}</label>
							<div
								titleLang="price_patient"
								class="form-control border-0 disabled-input"
							>
								{{ followup.price_patient | finNumber }}
							</div>
						</div>
						<div>
							<label>{{ "payorprices" | langVal }}</label>
							<div>
								<button
									titleLang="payorprices"
									tabindex="-1"
									class="btn btn-icon"
									(click)="openPayorPricesModal()"
									preIcon="payorprices"
								>
									<!-- {{ "payorprices_short" | langVal }} -->
								</button>
							</div>
						</div>
					}
				</div>
			}

			@if (
				isManualChargeShown == "yes" &&
				(!followup.invoice_id_patient || followup.invoice_id_patient < 0)
			) {
				<div class="d-flex w-100 gap-3 manual-charge-row grid-span-2">
					<div class="charged-manualy">
						<app-yes-no
							(onClick)="changeYesNo('charged_manualy')"
							[isCheck]="followup.charged_manualy == 'yes'"
						/>
						<label (click)="changeYesNo('charged_manualy')">{{
							"charged_manualy" | langVal
						}}</label>
					</div>
					<div class="charged-manualy-invoice colstat-small colstat">
						@if (followup.charged_manualy == "yes") {
							<div class="input-group">
								<app-gen-input
									title_ph_lang="external_invoice_id"
									[actualObj]="followup"
									[errors]="errors"
									className="border-0"
									fieldName="invoice_id"
									(keyupEvent)="validateField()"
									(changeEvent)="save()"
								/>
							</div>
						}
					</div>
					@if (
						!isMobile &&
						followup.payor_id &&
						(!followup.invoice_id_payor || followup.invoice_id_payor < 0)
					) {
						<div>
							<app-yes-no
								(onClick)="changeYesNo('charged_manualy_payor')"
								[isCheck]="followup.charged_manualy_payor == 'yes'"
							></app-yes-no>
							<label (click)="changeYesNo('charged_manualy_payor')">{{
								"charged_manualy_payor" | langVal
							}}</label>
						</div>
					}
				</div>
				<!-- @if (followup.payor_id) {
						<div class="row">
							<div class="colstat colstat-small-double">
								<app-gen-button-group
									[actualObj]="followup"
									fieldName="charged_manualy_payor"
									optionsListName="charged_manualy_payor_no_opts"
									(changeEvent)="save()"
								/>
							</div>
						</div>
					} -->
			}
		}
	</div>

	@if (enablePastFollowupsOnFollowup) {
		<div class="panel-body mixed-list-body">
			<app-mixed-list
				[patient]="patient"
				[followup_id]="$safeNavigationMigration(followup?.id)"
				preventShowingInList
			/>
		</div>
	}
	<div class="home-meeting-lower-details">
		@if (enableGroupAttendsOnFollowup && patient?.is_group == "yes") {
			<div class="panel-body group">
				<app-group-attends
					[group_id]="patient.id"
					[groupAttendRowPatientId]="groupAttendRowPatientId"
					[followup_id]="$safeNavigationMigration(followup?.id)"
					(hasNonAttendOutput)="hasNonAttend = $event"
				/>
			</div>
		}
		@if (permsService.perms?.clinical) {
			<div class="d-flex align-items-center justify-content-between m-0">
				<div>
					<p class="followup-title">
						{{
							(patient?.is_group == "no"
								? "medical_record"
								: "medical_record_group"
							) | langVal
						}}
					</p>
				</div>
				<div>
					@if (isSaving) {
						<div
							[class.updated-saving]="
								isMobile &&
								showPersonalMemorandum == 'no' &&
								!isPMShown &&
								!followup.remarks
							"
							style="text-align: end"
						>
							<span
								class="strong error-soft"
								style="padding-inline: 20px"
								>{{ "saving" | langVal }}
							</span>
						</div>
					}
				</div>
			</div>

			<div class="medical-record">
				<div class="col-12">
					<app-wysiwyg
						#descriptionWysiwyg
						[actualObj]="followup"
						fieldName="description"
						tabindex="1"
						[title_ph_lang]="
							patient?.is_group == 'yes'
								? 'medical_record_group'
								: 'medical_record'
						"
						(changeEvent)="save()"
						(uploadFile)="uploadImage(null, $event)"
						(keyupEvent)="onFocus('description'); validateField()"
						[showTestsBtn]="!!patient"
						(openTests)="modalProps = { name: 'tests-menu' }"
						[showAutotextsBtn]="!!patient"
						(openAutotexts)="modalProps = { name: 'autotext-menu' }"
						[allowsImageUpload]="!!patient"
						[initHeight]="
							eventsService.isMobile ? eventsService.MobileHeight - 660 : 0
						"
					/>
				</div>
			</div>

			@if (showPersonalMemorandum == "yes" || isPMShown || followup.remarks) {
				<div class="row m-0">
					<div class="col-12">
						<p class="followup-title">{{ "personal_memorandum" | langVal }}</p>
					</div>
				</div>

				<!-- <div class="row"> -->
				<div
					class="col-12"
					titleLang="personal_memorandum"
				>
					<app-wysiwyg
						#remarksWysiwyg
						[actualObj]="followup"
						fieldName="remarks"
						tabindex="2"
						title_ph_lang="personal_memorandum"
						(changeEvent)="save()"
						[allowsImageUpload]="!!patient"
						(uploadFile)="uploadImage(null, $event)"
						(keyupEvent)="onFocus('remarks'); validateField()"
					></app-wysiwyg>
				</div>
				<!-- </div> -->
			}
			@if (followup.supervisor_notes) {
				<div
					class="row"
					style="border: #8fdf82; border-style: dashed"
				>
					<div
						class="col-12"
						[innerHTML]="followup.supervisor_notes | safeHtml"
					></div>
				</div>
			}
			@if (patient) {
				<div
					class="d-flex gap-2 align-items-center mb-4"
					style="margin-inline: 20px"
				>
					<div class="button-group duo tab">
						@if (
							showPersonalMemorandum == "no" && !isPMShown && !followup.remarks
						) {
							<!-- <div style="width: fit-content"> -->
							<button
								titleLang="show_personal_memorandum"
								tabindex="-1"
								class="btn btn-default btn-tab"
								(click)="isPMShown = !isPMShown"
							>
								{{ "show_personal_memorandum" | langVal }}
							</button>
							<!-- </div> -->
						}
						<!-- <div style="width: fit-content"> -->
						<app-gen-file-input
							#imageUploadInput
							fileType="image"
							[actualObj]="this"
							className="btn btn-default btn-tab btn-image"
							fieldName="newImageObj"
							title_ph_lang="upload_image"
							[showImagePreview]="false"
							(changeEvent)="uploadImage($event)"
							[isUploading]="isUploading"
						/>
					</div>
					<!-- </div> -->
					@if (followup.created_at !== followup.updated_at) {
						<div
							[class.updated-saving]="
								showPersonalMemorandum == 'no' &&
								!isPMShown &&
								!followup.remarks
							"
							style="
								text-align: end;
								margin-inline-start: auto;
								color: var(--green);
								font-weight: 600;
							"
						>
							<div titleLang="updated_at">
								{{ "last_update" | langVal }}: {{ followup.updated_at_display }}
							</div>
						</div>
					}
				</div>
			}
		}
		<div class="images-container">
			@for (imageObj of followup.images; track imageObj) {
				<div>
					<div [spinner]="imageObj.isDeleting">
						@if (!imageObj.isDeleting) {
							<app-icon
								icon="cancel"
								(click)="deleteImage(imageObj)"
							/>
						}
					</div>

					<img
						[src]="imageObj.id | serverImg: 'followup-image'"
						(click)="openImage($index)"
					/>
				</div>
			}
		</div>
		@if (showVersions == "yes") {
			<div class="submit-wrap text-end">
				<button
					titleLang="versions"
					tabindex="-1"
					class="btn btn-primary no-mob"
					(click)="modalProps = { name: 'table-display-medilogs' }"
				>
					{{ "versions" | langVal }}
				</button>
			</div>
		}
	</div>
	<!-- <hr /> -->
	<!-- <div> -->
	<div class="bottom-row-buttons">
		<div class="p-0 next-previous">
			@if (!isModalMode) {
				<button
					class="btn btn-primary"
					(click)="save(true, true)"
					tabClick
					titleLang="next"
					tabindex="3"
					postIcon="next"
				>
					{{ "next" | langVal }}
				</button>
				<button
					class="btn btn-primary"
					titleLang="previous"
					(click)="save(true, false)"
					preIcon="previous"
				>
					{{ "previous" | langVal }}
				</button>
			}
		</div>
		@if (patient) {
			<div class="action-buttons p-0">
				@if (
					permsService.perms?.administrative &&
					(patient?.is_group == "no" ||
						(patient?.is_group == "yes" && patient?.charge_mode == "by_group"))
				) {
					<button
						class="btn btn-primary"
						titleLang="invoice_short"
						(click)="addInvoiceEv.emit()"
						preIcon="money-white"
						isImg
					>
						{{ "invoice_short" | langVal }}
					</button>
				}

				<button
					class="btn btn-primary"
					titleLang="medical_letter"
					(click)="addDocumentEv.emit()"
					preIcon="document-white"
					isImg
				>
					{{ "medical_letter" | langVal }}
				</button>

				<button
					class="btn btn-primary"
					titleLang="upload_file"
					(click)="openUploadDocumentModalEv.emit()"
					preIcon="document-white"
					isImg
				>
					{{ "upload_file" | langVal }}
				</button>
				<ng-content select="[patientImages]" />
			</div>
		}
	</div>
	<!-- </div> -->
</div>
@switch (modalProps?.name) {
	@case ("image-gallery") {
		<app-image-gallery
			(onClose)="modalProps = null"
			[images]="modalProps.images"
			[curImagePosition]="modalProps.curImagePosition"
		/>
	}
	@case ("autotext-menu") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="autotexts"
			modalWrapperClass="modal-650"
		>
			<app-autotext-menu (onClose)="modalProps = null; insertText($event)" />
		</app-modal-wrap>
	}
	@case ("tests-menu") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="tests"
			modalWrapperClass="modal-small-width"
		>
			<app-tests-menu
				(onClose)="modalProps = null; insertText($event)"
				[patient_id]="patient.id"
				[in_followup]="true"
			/>
		</app-modal-wrap>
	}
	@case ("group-attends") {
		<app-modal-wrap
			(onClose)="modalProps = null; loadFollowupHasNonAttend()"
			title="group_attendancy"
			modalWrapperClass="modal-800"
		>
			<app-group-attends
				(onClose)="modalProps = null; loadFollowupHasNonAttend()"
				[group_id]="modalProps.group_id"
				[followup_id]="modalProps.followup_id"
			/>
		</app-modal-wrap>
	}
	@case ("table-display-medilogs") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="medilogs"
			modalWrapperClass="modal-wide"
		>
			<app-gen-table-display
				(onClose)="modalProps = null"
				tableName="medilogs"
				filterField="resource"
				filterFieldValue="followup"
				[filterFieldApiObject]="{ resource_id: followup.id }"
			/>
		</app-modal-wrap>
	}
	@case ("table-display-payorprices") {
		<app-modal-wrap
			(onClose)="modalProps = null; save()"
			title="payorprices"
			modalWrapperClass="modal-wide"
		>
			<app-gen-table-display
				(onClose)="modalProps = null; save()"
				tableName="payorprices"
				filterField="payor_id"
				[objectRow]="modalProps.payor"
			/>
		</app-modal-wrap>
	}
}
